/**
 * V1.1 Task 4 (2026-04-26) — Shared helpers + styles for the orphan-audit
 * dry-run report viewer. Pulled out of the page file to keep
 * `StorageOrphanAuditPage.tsx` under the 300-line component cap.
 */

export function formatBytes(bytes: number): string {
  if (bytes <= 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** i;
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function formatIso(unixMs: number): string {
  if (unixMs <= 0) return "—";
  const iso = new Date(unixMs).toISOString().replace("T", " ").slice(0, 16);
  return `${iso} UTC`;
}

export const auditStyles: Record<string, React.CSSProperties> = {
  banner: {
    padding: "10px 14px",
    marginBottom: 16,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg-secondary)",
    fontSize: 13,
    color: "var(--color-text-secondary)",
  },
  card: {
    padding: 16,
    marginBottom: 20,
    borderRadius: 6,
    border: "1px solid var(--color-border)",
    background: "var(--color-bg)",
  },
  cardTitle: {
    margin: 0,
    marginBottom: 12,
    fontSize: 14,
    fontWeight: 600,
    color: "var(--color-text)",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
  },
  dl: {
    margin: 0,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: 12,
  },
  field: {
    margin: 0,
  },
  fieldLabel: {
    margin: 0,
    fontSize: 11,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    marginBottom: 4,
  },
  fieldValue: {
    margin: 0,
    fontSize: 14,
    fontWeight: 500,
    color: "var(--color-text)",
  },
  warning: {
    marginTop: 12,
    padding: "8px 12px",
    borderRadius: 4,
    background: "rgba(255, 165, 0, 0.08)",
    color: "var(--color-warning, #d97706)",
    fontSize: 13,
    border: "1px solid rgba(255, 165, 0, 0.25)",
  },
  emptyText: {
    fontSize: 14,
    color: "var(--color-text-secondary)",
    padding: "16px 0",
  },
  mono: {
    fontFamily: "monospace",
    fontSize: 12,
  },
};
